import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";

const STORAGE_KEY = "queensway_edit_mode";
const EditModeContext = createContext(null);

export function EditModeProvider({ children }) {
  const { user } = useAuth();
  const [editMode, setEditMode] = useState(false);
  // Currently-open editor — { settingKey, kEn, kFr, label } or null
  const [target, setTarget] = useState(null);

  // Only admins can enter edit mode; auto-exit if they log out.
  const isAdmin = user?.role === "admin";

  useEffect(() => {
    if (!isAdmin) {
      setEditMode(false);
      setTarget(null);
      return;
    }
    try {
      setEditMode(localStorage.getItem(STORAGE_KEY) === "1");
    } catch {
      /* ignore */
    }
  }, [isAdmin]);

  const toggle = useCallback(() => {
    setEditMode((v) => {
      const next = !v;
      try {
        localStorage.setItem(STORAGE_KEY, next ? "1" : "0");
      } catch {
        /* ignore */
      }
      if (!next) setTarget(null);
      return next;
    });
  }, []);

  return (
    <EditModeContext.Provider
      value={{ editMode, toggle, target, setTarget, isAdmin }}
    >
      {children}
    </EditModeContext.Provider>
  );
}

export function useEditMode() {
  const ctx = useContext(EditModeContext);
  if (!ctx) throw new Error("useEditMode must be used within EditModeProvider");
  return ctx;
}
